import { Button, Input, InputGroup } from "reactstrap";

export const SearchInput = ({
  testId,
  icon,
  value,
  placeholder = "Search...",
  disabled,
  onChange,
  onClick,
  className,
  onKeyPress,
  ...props
}) => {
  return (
    <InputGroup className={className}>
      <Input
        data-testid={testId}
        className="me-2"
        type="search"
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        {...props}
      />
      <Button data-testid={testId ? `${testId}-submit` : undefined} color="primary" onClick={onClick}>
        Search
      </Button>
    </InputGroup>
  );
};
